export default __webpack_public_path__ + "static/media/PathHorizontal.7dbecca4.webp";